/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */

import { ModelRuleGroupData } from './modelRuleData';
import { TreeOptionSelections } from '../data/optionsSelection';
import { SLTXFormatRootFile } from '../../fileFormats/sltx/sltx';

export class RulesEvaluation {

  // Check if a given set of conditions are fulfilled in the current selection state
  public static checkIfConditionsAreFulfilled(
    conditions : ModelRuleGroupData[],
    configSelectionState : TreeOptionSelections,
    sltxFile : SLTXFormatRootFile,
  ) : boolean {

    let allConditionsFulfilled = true;

    // Go through the groups defined in the SLTX file
    // It is important to go through the groups in the SLTX file, because
    // the we are respecting the order.

    const sltxFileGroups = sltxFile.groups;

    if (sltxFileGroups === undefined) {
      console.error('SLTXFile Groups are undefined');
      return false;
    }

    // Go through all the groups in the SLTX file
    for (const sltxFileGroup of sltxFileGroups) {

      // Check if this group is part of the filtering rule
      const ruleCondition = conditions.find((condition) => condition.groupID === sltxFileGroup.id);

      if (ruleCondition === undefined) {
        // This group is not part of the filtering rule
        // So we can skip it
        // eslint-disable-next-line no-continue
        continue;
      }

      const conditionFulfilled = this.checkIfConditionIsFulfilled(
        ruleCondition,
        sltxFile,
        configSelectionState,
      );

      if (conditionFulfilled === false) {
        allConditionsFulfilled = false;
        break;
      }
    }

    return allConditionsFulfilled;
  }

  // Check if a given condition is fulfilled in the current selection state
  private static checkIfConditionIsFulfilled(
    ruleCondition : ModelRuleGroupData,
    sltxFile : SLTXFormatRootFile,
    configSelectionState : TreeOptionSelections,
  ) : boolean {

    const conditionGroupID = ruleCondition.groupID;

    if (conditionGroupID === undefined) {
      return false;
    }

    // Grab the group name from the group ID
    const conditionGroupName = this.getGroupNameFromGroupID(sltxFile, conditionGroupID);
    if (conditionGroupName === undefined) {
      console.error('Could not find group name from group ID');
      return false;
    }

    // Get the selection state for the group
    const groupSelection = RulesEvaluation.getGroupSelection(
      sltxFile,
      configSelectionState,
      conditionGroupName,
    );

    if (groupSelection === undefined) {
      console.log('Could not find selection for group', conditionGroupName);
      return false;
    }

    // Check if this selection is one that fulfills the condition
    const conditionFulfilled = ruleCondition.options.includes(groupSelection);

    return conditionFulfilled;
  }

  // Given the file structure, and a group ID, return the name of the group
  private static getGroupNameFromGroupID(
    sltxFile : SLTXFormatRootFile,
    groupID : number,
  ) : string | undefined {

    const { groups } = sltxFile;
    if (groups === undefined) {
      console.error('SLTXFile Groups are undefined');
      return undefined;
    }

    const matchGroup = groups.find((group) => group.id === groupID);

    if (matchGroup === undefined) {

      console.error('Could not find group with ID: ', groupID);
      return undefined;
    }

    return matchGroup.name;
  }

  // Given he class that represents the user selection, and the name of the group,
  // return the value selected by the user for that group.
  private static getGroupSelection(
    sltxFile : SLTXFormatRootFile,
    configSelectionState : TreeOptionSelections,
    groupName : string,
  ) : number | undefined {

    const modelGroups = sltxFile.groups;
    if (modelGroups === undefined) {
      return undefined;
    }

    // Go through the options in the SLTX file and find the ID

    const modelGroup = modelGroups.find((group) => group.name === groupName);

    if (modelGroup === undefined) {
      return undefined;
    }

    // Find this ID in the selection state
    const selection = configSelectionState.find((s) => s.groupID === modelGroup.id);

    if (selection === undefined) {
      return undefined;
    }

    return selection.optionID;
  }
}
